import React, { useEffect, useState } from 'react';
import styles from './Styles/Prices.module.css';
import {
  getPrices,
  setPrices,
  updatePrices,
} from '../../Services/arndAPI';
import Loader from '../../Components/Loader/Loader';

export default function Prices({ user }) {
  const [imagePrice, setImagePrice] = useState('');
  const [albumPrice, setAlbumPrice] = useState('');
  const [discountAmount, setDiscountAmount] = useState('');
  const [expirationTime, setExpirationTime] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [hasPrices, setHasPrices] = useState(false);

  const fetchPrices = async () => {
    setLoading(true);
    setStatus('');
    try {
      const data = await getPrices();
      setImagePrice(data.imagesPrice);
      setAlbumPrice(data.albumPrice);
      setDiscountAmount(data.discountAmount);
      setExpirationTime(data.expirationTime || '');
      setHasPrices(true);
    } catch (err) {
      setStatus('No prices found. You can create them.');
      setHasPrices(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrices();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Saving...');
    const payload = {
      imagePrice: parseFloat(imagePrice),
      albumPrice: parseFloat(albumPrice),
      discountAmount: parseFloat(discountAmount),
      expirationTime: parseInt(expirationTime),
    };

    try {
      if (hasPrices) {
        await updatePrices(payload);
      } else {
        await setPrices(payload);
      }
      setStatus('Prices saved successfully.');
      setHasPrices(true);
    } catch (err) {
      setStatus('Failed to save prices.');
    }
  };

  return (
    <div className={styles.container}>
      <h2>Manage Prices</h2>

      {loading ? (
        <Loader />
      ) : (
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="imagePrice">Image Price ($)</label>
            <input
              id="imagePrice"
              type="number"
              step="0.01"
              value={imagePrice}
              onChange={(e) => setImagePrice(e.target.value)}
              required
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="albumPrice">Album Price ($)</label>
            <input
              id="albumPrice"
              type="number"
              step="0.01"
              value={albumPrice}
              onChange={(e) => setAlbumPrice(e.target.value)}
              required
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="discountAmount">Discount Percentage (%)</label>
            <input
              id="discountAmount"
              type="number"
              step="0.01"
              value={discountAmount}
              onChange={(e) => setDiscountAmount(e.target.value)}
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="expirationTime">Expiration Time (days)</label>
            <input
              id="expirationTime"
              type="number"
              value={expirationTime}
              onChange={(e) => setExpirationTime(e.target.value)}
              required
            />
          </div>

          <button type="submit" className={styles.saveBtn}>Save</button>
          {status && <div className={styles.status}>{status}</div>}
        </form>
      )}
    </div>
  );
}
